import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

// React-shared.
import Table from '@exonet/react-shared/lib/Elements/Table';

// Utilities.
import getTranslations from 'app/client/utilities/i18n/dataManager';

// Styled.
import * as S from './styled';

const TranslatedTable = ({ subtitle, type, ...props }) => {
  const { t } = useTranslation();

  const typeName = useMemo(() => {
    if (typeof type !== 'object') {
      return type?.toLowerCase();
    }

    if (type.options?.keepCapitalization) {
      return type.value;
    }

    return type.value.toLowerCase();
  }, [type]);

  const noData = useMemo(
    () => typeName && t('core:dataManager.noDataForType', { type: typeName }),
    [t, typeName],
  );

  return (
    <>
      {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
      <Table translations={getTranslations(t, { noData })} {...props} />
    </>
  );
};

TranslatedTable.propTypes = {
  subtitle: PropTypes.string,
  type: PropTypes.oneOfType([
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      options: PropTypes.shape({
        keepCapitalization: PropTypes.bool,
      }),
    }),
    PropTypes.string,
  ]),
};

export default TranslatedTable;
